import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/store/sessionStore';
import { FullPageSpinner } from '@/design-system/components/FullPageSpinner';

type Props = {
  children: React.ReactNode;
  role?: 'admin' | 'user';
};

export function AuthGuard({ children, role }: Props) {
  const { status, user } = useSession();
  const location = useLocation();

  if (status === 'loading') return <FullPageSpinner />;

  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (role === 'admin' && user.role !== 'admin') {
    return <Navigate to="/lobby" replace />;
  }

  return <>{children}</>;
}
